import { render } from "./NavLinks.vue?vue&type=template&id=66aa4f8a&scoped=true&bindings={}"
import script from "./NavLinks.vue?vue&type=script&lang=js"
export * from "./NavLinks.vue?vue&type=script&lang=js"

import "./NavLinks.vue?vue&type=style&index=0&id=66aa4f8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66aa4f8a"

export default script